'use client'

import { Box, Typography } from '@mui/material'
import { Link } from '@biolumina/ui/components/link/link'
import { useGlobalState } from '@biolumina/ui/context/globalStateProvider'
import { StyledSitemap } from './page.styles'
import { List } from '@biolumina/ui/components/list/list'
import { ListItem } from '@biolumina/ui/components/listItem/listItem'
import { Footnote } from '@biolumina/ui/components/footnote/footnote'

export default function Sitemap() {
  const {
    siteData: { pageData },
  } = useGlobalState()

  return (
    <StyledSitemap>
      <Box className="sitemap-content">
        <Typography variant="h2" fontWeight={800} color="text.primary" mb={4}>
          Sitemap
        </Typography>
        <Box>
          {Object.entries(pageData)
            .filter(([, value]) => value.sitemap)
            .map(([key, value]) => {
              return (
                <Box key={key} mb={4}>
                  <Link variant="h2" mb={0} href={value.href}>
                    {value.display}
                  </Link>
                  {value.children && (
                    <List>
                      {value.children.map((child) => {
                        return (
                          <ListItem variant="h4" key={child.href}>
                            <Link href={`${child.href}`}>{child.display}</Link>
                          </ListItem>
                        )
                      })}
                    </List>
                  )}
                </Box>
              )
            })}
        </Box>
		<Footnote className="defs" marginBottom="40px">
         NSCLC=non-small cell lung cancer; ROS1+=ROS proto-oncogene 1–positive.
        </Footnote>
      </Box>
    </StyledSitemap>
  )
}
